"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgMeterFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 24a19.76 19.76 0 00-8.58 1.91c-.26.12-.53.27-.82.43a13.9 13.9 0 0018.84 0c-.26-.15-.51-.3-.75-.42A20.71 20.71 0 0016 24z" }),
        React.createElement("path", { d: "M15.37 22l3.74-7.47 1.78.9-3.3 6.61a22.61 22.61 0 018 2l1.26.73a14 14 0 10-21.69 0c.48-.28 1-.54 1.38-.76A21.8 21.8 0 0115.37 22zM24 12.8a1.2 1.2 0 11-1.2 1.2 1.2 1.2 0 011.2-1.2zm-3-4a1.2 1.2 0 11-1.2 1.2A1.2 1.2 0 0121 8.8zm-5-2A1.2 1.2 0 1114.8 8 1.2 1.2 0 0116 6.8zm-5 2A1.2 1.2 0 119.8 10 1.2 1.2 0 0111 8.8zm-3 4A1.2 1.2 0 116.8 14 1.2 1.2 0 018 12.8z" })));
}
exports.default = SvgMeterFilled;
//# sourceMappingURL=MeterFilled.js.map